import React from 'react';
import { Form, Input, Button, Radio, InputNumber, Card, message, Alert } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import RichText from 'components_business/RichText/Index.js';
import UploadImage from 'components_business/UploadImage/Index.js';
import { getUrlSearchParams, formatPrice, parsePrice, getStringLength } from 'utils/utils.js';
import { urlCollect } from 'services/service-utils.js';
import { COMMODITY_PRICE } from 'utils/const.js';
import Skus from '../Modal/Skus.js';
import styles from './SaveOrUpdate.less';

const maxLength = 2000;

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 15 },
  },
};

@connect(({ loading, merchantCommodityDetail, SkusEdit }) => ({
  submitting: loading.effects['merchantCommodityDetail/submit'],
  detail: merchantCommodityDetail.detail,
  receiveAccount: merchantCommodityDetail.receiveAccount,
  skusCombinationList: SkusEdit.skusCombinationList,
  loading: loading.effects['merchantCommodityDetail/fetchDetail'],
  showRichTextError: merchantCommodityDetail.showRichTextError,
}))
@Form.create()
export default class SaveOrUpdate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      richTextContent: '',
    };

    this.imgList = [];
    this.searchParams = getUrlSearchParams(props.location);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.handleUploadChange = this.handleUploadChange.bind(this);
  }

  componentDidMount() {
    const { type, id } = this.searchParams;
    switch (type) {
      case 'add':
        // 新增时清空规格原有数据
        this.props.dispatch({
          type: 'SkusEdit/initSkus',
          _skusList: [],
        });

        this.props.dispatch({ type: 'merchantCommodityDetail/fetchReceiveAccount' });
        break;
      case 'edit':
        this.props
          .dispatch({
            type: 'merchantCommodityDetail/fetchDetail',
            id,
          })
          .then(detail => {
            this.imgList = detail.images.split(',');
          });
        break;
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
    const newDescription = nextProps.detail.description;
    const oldDescription = this.props.detail.description;
    if (newDescription !== oldDescription) {
      this.setState({
        richTextContent: newDescription,
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'merchantCommodityDetail/resetState',
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { form, dispatch, receiveAccount, detail, skusCombinationList } = this.props;

    const validateResult = skusCombinationList.some(item => {
      return item.originalPrice === null || item.originalPrice === '';
    });
    if (validateResult) {
      return message.error('规格必须设置价格');
    }

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (getStringLength(this.state.richTextContent) > maxLength) {
          message.error('商品描述过长');
          return;
        }

        const payload = {
          ...values,
          price: skusCombinationList.length ? 0 : parsePrice(values.price),
          commodityId: null,
          images: this.imgList.join(','),
          properties: skusCombinationList,
          description: this.state.richTextContent,
        };

        if (this.searchParams.type === 'add') {
          const account = receiveAccount.find(q => q.appId === values.receiveAccountAppId);
          payload.isPrivate = account.isPrivate;
          payload.appId = account.appId;
        } else if (this.searchParams.type === 'edit') {
          payload.commodityId = detail.commodityId;

          payload.isPrivate = detail.isPrivate;
          payload.appId = detail.appId;
        }

        dispatch({
          type: 'merchantCommodityDetail/submit',
          payload,
        }).then(commodityId => {
          dispatch(routerRedux.replace(`/merchant/commodity/success?commodityId=${commodityId}`));
        });
      }
    });
  }

  handelRichTextChange(content) {
    this.setState({
      richTextContent: content,
    });
  }

  handleRichTextBlur(content) {
    this.props.dispatch({
      type: 'merchantCommodityDetail/saveShowRichTextError',
      showRichTextError: getStringLength(content) > maxLength,
    });
  }

  handelBackToList() {
    this.props.dispatch(routerRedux.goBack());
  }

  handelInitialValue(fieldName) {
    if (this.searchParams.type === 'edit') {
      if (fieldName === 'price') {
        return formatPrice(this.props.detail[fieldName], { isToString: false });
      }

      return this.props.detail[fieldName];
    }

    return null;
  }

  handleUploadChange(urlList) {
    this.imgList = urlList;
  }

  renderCommodityId() {
    if (this.searchParams.type === 'edit') {
      return (
        <FormItem {...formItemLayout} label="商品号">
          <div>{this.props.detail.commodityId}</div>
        </FormItem>
      );
    }
  }

  renderIsPrivate() {
    const { form, detail, receiveAccount } = this.props;
    const { getFieldDecorator } = form;
    const initialValue =
      receiveAccount && receiveAccount.length === 1 ? receiveAccount[0].appId : '';

    let component = (
      <RadioGroup>
        {receiveAccount.map(account => (
          <Radio key={account.appId} value={account.appId}>
            {account.name}
          </Radio>
        ))}
      </RadioGroup>
    );
    let rules = [{ required: true, message: '请选择收款账号' }];

    if (this.searchParams.type === 'edit') {
      const account = receiveAccount.find(q => q.appId === detail.appId);
      component = <div>{account ? account.name : ''}</div>;
      rules = [];
    }

    return (
      <FormItem {...formItemLayout} label="收款账号">
        {getFieldDecorator('receiveAccountAppId', {
          rules,
          initialValue,
        })(component)}
      </FormItem>
    );
  }

  renderUploadImg() {
    const { type } = this.searchParams;

    let initialValue = [];

    if (type === 'edit') {
      initialValue = this.props.detail.images.split(',');
    }

    return (
      <UploadImage
        uploadApi={urlCollect.fileUpload}
        uploadField="files[]"
        uploadParam={{
          type: 'jssdk',
        }}
        type="edit"
        maxLength={5}
        imgMaxSize={1}
        description="默认第一张图为封面，最多上传5张；建议尺寸：800*600像素，小于1M，支持jpg、png、jpeg格式"
        onChange={this.handleUploadChange}
        initialValue={initialValue}
      />
    );
  }

  renderContent() {
    const {
      submitting,
      loading,
      detail,
      form,
      showRichTextError,
      skusCombinationList,
      detail: { description },
    } = this.props;
    if (this.searchParams.type === 'edit' && (loading || Object.keys(detail).length === 0)) {
      return null;
    }

    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit} className={styles.root}>
        {this.renderCommodityId.call(this)}

        <FormItem {...formItemLayout} label="商品名称">
          {getFieldDecorator('name', {
            initialValue: this.handelInitialValue.call(this, 'name'),
            rules: [
              { required: true, message: '请输入商品名称' },
              { max: 32, message: '商品名称不能多于32个字' },
            ],
          })(<Input placeholder="商品名称不能多于32个字" />)}
        </FormItem>

        {this.renderIsPrivate.call(this)}

        <FormItem {...formItemLayout} label="图片">
          {getFieldDecorator('images', {
            initialValue: this.handelInitialValue.call(this, 'images'),
            rules: [{ required: true, message: '请上传图片' }],
          })(this.renderUploadImg())}
        </FormItem>

        <FormItem {...formItemLayout} label="规格">
          {getFieldDecorator('skus')(<Skus type="edit" />)}
        </FormItem>

        {skusCombinationList.length === 0 && (
          <FormItem {...formItemLayout} label="价格设置（元）">
            {getFieldDecorator('price', {
              initialValue: this.handelInitialValue.call(this, 'price'),
              rules: [
                { required: true, message: '请输入价格' },
                {
                  validator: (rule, value, callback) => {
                    if (skusCombinationList.length) {
                      return callback();
                    }

                    if (value === null) {
                      return callback('');
                    }

                    if (value <= COMMODITY_PRICE.min) {
                      return callback(`商品价格必须大于${COMMODITY_PRICE.min}`);
                    }

                    if (value > COMMODITY_PRICE.max) {
                      return callback(`商品价格必须小于${COMMODITY_PRICE.max}`);
                    }

                    return callback();
                  },
                },
              ],
            })(
              <InputNumber
                placeholder="请输入价格"
                disabled={!!skusCombinationList.length}
                precision={2}
              />
            )}
          </FormItem>
        )}

        <FormItem {...formItemLayout} label="商品描述">
          <RichText
            initialValue={description}
            onChange={this.handelRichTextChange.bind(this)}
            onBlur={this.handleRichTextBlur.bind(this)}
          />

          {showRichTextError && (
            <Alert message="商品描述过长" type="error" showIcon className="rich-text-error" />
          )}
        </FormItem>

        <FormItem className="operation-button-wrap">
          <Button type="primary" htmlType="submit" loading={submitting}>
            提交
          </Button>
          <Button onClick={this.handelBackToList.bind(this)}>返回</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Card bordered={false} loading={loading}>
        {this.renderContent()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/Detail/SaveOrUpdate.js